import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Dropdown, Offcanvas, ListGroup } from 'react-bootstrap';
import { FaUser, FaFileAlt, FaExchangeAlt, FaAngleDoubleLeft, FaAngleDoubleRight, FaSignOutAlt, FaTag, FaUsers, FaBox, FaWarehouse, FaBoxes, FaFolderOpen, FaBuilding, FaUserCircle, FaBars, FaChartBar, FaCog, FaTractor, FaSeedling, FaClipboardList, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Outlet, useNavigate } from 'react-router-dom';
import ConfirmationModal from '../Modals/ConfirmationModal';
import useNavigationActions from '../../hooks/Home/useNavigationActions';
import useUserRoles from '../../hooks/Home/useUserRoles';
import useUsernameFromToken from '../../hooks/useUsernameFromToken';
import { usePermissionsContext } from '../../context/PermissionsContext';
import './Home.css';

const Home = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [title, setTitle] = useState('');
  const [username, setUsername] = useState('');
  const [selectedMenu, setSelectedMenu] = useState('');
  const navigate = useNavigate();
  const userRoles = useUserRoles();
  const { permissions, hasPermission } = usePermissionsContext();
  const {
    showOffcanvas,
    showLogoutModal,
    handleOffcanvasClose,
    handleOffcanvasShow,
    handleLogoutConfirm,
    handleLogout,
    handleModalClose,
    navigateTo,
  } = useNavigationActions(navigate);

  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed);
  };

  const hasAdminRole = userRoles.includes('ADMIN');
  
  // Helper function: se tiver permissões configuradas, usa elas; senão, usa ADMIN
  const canAccess = (permissionKey) => {
    const hasAnyPermissions = Object.keys(permissions).length > 0;
    if (hasAnyPermissions) {
      return hasPermission(permissionKey);
    }
    return hasAdminRole;
  };

  const { getUsernameFromToken } = useUsernameFromToken();

  useEffect(() => {
    const name = getUsernameFromToken();
    if (name) {
      setUsername(name);
    }
    
    const documentTitle = document.title.toUpperCase();
    setTitle(documentTitle);
  }, [getUsernameFromToken]);

  const handleMenuSelect = (menu) => {
    setSelectedMenu(selectedMenu === menu ? '' : menu);
  };

  return (
    <div className="main-container">
      <Navbar expand="lg" className="navbar-custom justify-content-between fixed-top">
        <div className="d-lg-none">
          <FaBars size={45} className='text-color' onClick={handleOffcanvasShow} style={{ cursor: 'pointer', padding: '10px' }} />
        </div>
        
        <Link to="/dashboard" className="navbar-brand text-color ms-3 d-none d-lg-block">
          <h1 style={{ fontSize: '24px', margin: '0', fontWeight: 'bold' }}>{title}</h1>
        </Link>

        <Nav className="ms-auto">
          <Dropdown align="end">
            <Dropdown.Toggle variant="white" id="dropdown-user" className="border-0">
              <span className='text-color' style={{ fontWeight: 'bold', marginRight: '5px' }}>{username}</span>
              <FaUserCircle size={30} className='text-color' />
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-custom">
              <Dropdown.Item onClick={() => navigateTo('/profile')}>
                <div>
                  <FaUserCircle className='me-2' /> Minha Conta
                </div>
              </Dropdown.Item>
              {canAccess('configurationsView') && (
                <Dropdown.Item onClick={() => navigateTo('/settings')}>
                  <div>
                    <FaCog className='me-2' /> Configurações
                  </div>
                </Dropdown.Item>
              )}
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>
                <div>
                  <FaSignOutAlt className='mw-2' /> Sair
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar>

      <div className={`sidebar sidebar-custom d-none d-lg-block ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="toggle-menu" onClick={toggleMenu}>
        {isCollapsed ? <FaAngleDoubleRight title='Mostrar'/> : <FaAngleDoubleLeft title='Esconder'/>}
        </div>
        <ListGroup variant="flush">
          {canAccess('chartsView') && (
            <ListGroup.Item action onClick={() => navigateTo('/dashboard')}>
              <FaChartBar className="me-2" title="Dashboard"/> <span>Dashboard</span>
            </ListGroup.Item>
          )}
          <ListGroup.Item action onClick={() => handleMenuSelect('cadastros')} className="d-flex justify-content-between align-items-center">
            <div>
              <FaFolderOpen className="me-2" title="Cadastros"/> <span>Cadastros</span>
            </div>
            {selectedMenu === 'cadastros' ? (
              <FaChevronUp className="ms-auto" style={{ fontSize: '0.8em' }} />
            ) : (
              <FaChevronDown className="ms-auto" style={{ fontSize: '0.8em' }} />
            )}
          </ListGroup.Item>
          {selectedMenu === 'cadastros' && (
            <ListGroup className="ms-3">
              {canAccess('companyView') && (
                <ListGroup.Item action onClick={() => navigateTo('/company')}>
                  <FaBuilding className="me-2" title="Empresas"/> <span>Empresas</span>
                </ListGroup.Item>
              )}
              {canAccess('discountView') && (
                <ListGroup.Item action onClick={() => navigateTo('/discounts')}>
                  <FaTag className="me-2" title="Descontos"/> <span>Descontos</span>
                </ListGroup.Item>
              )}
              <ListGroup.Item action onClick={() => navigateTo('/farm')}>
                <FaTractor className="me-2" title="Fazendas"/> <span>Fazendas</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/lot')}>
                <FaBoxes className="me-2" title="Lotes"/> <span>Lotes</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/person')}>
                <FaUsers className="me-2" title="Pessoas"/> <span>Pessoas</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/product')}>
                <FaBox className="me-2" title="Produtos"/> <span>Produtos</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/harvest')}>
                <FaSeedling className="me-2" title="Safras"/> <span>Safras</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/silo')}>
                <FaWarehouse className="me-2" title="Silos"/> <span>Silos</span>
              </ListGroup.Item>
              {canAccess('usersView') && (
                <ListGroup.Item action onClick={() => navigateTo('/users')}>
                  <FaUser className="me-2" title="Usuários"/> <span>Usuários</span>
                </ListGroup.Item>
              )}
            </ListGroup>
          )}
          <ListGroup.Item action onClick={() => navigateTo('/romaneios')}>
            <FaClipboardList className="me-2" title="Romaneios"/> <span>Romaneios</span>
          </ListGroup.Item>
          {canAccess('transferView') && (
            <ListGroup>
              <ListGroup.Item action onClick={() => navigateTo('/transfer')}>
                <FaExchangeAlt className="me-2" title="Transferências"/> <span>Transferências</span>
              </ListGroup.Item>
            </ListGroup>
          )}
          <ListGroup.Item action onClick={() => handleMenuSelect('relatorios')} className="d-flex justify-content-between align-items-center">
            <div>
              <FaFileAlt className="me-2" title="Relatórios"/> <span>Relatórios</span>
            </div>
            {selectedMenu === 'relatorios' ? (
              <FaChevronUp className="ms-auto" style={{ fontSize: '0.8em' }} />
            ) : (
              <FaChevronDown className="ms-auto" style={{ fontSize: '0.8em' }} />
            )}
          </ListGroup.Item>
          {selectedMenu === 'relatorios' && (
            <ListGroup className="ms-3">
              <ListGroup.Item action onClick={() => navigateTo('/reports/romaneio')}>
                <FaClipboardList className="me-2" title="Romaneios"/> <span>Romaneios</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/reports/estoque')}>
                <FaBox className="me-2" title="Estoque"/> <span>Estoque</span>
              </ListGroup.Item>
              <ListGroup.Item action onClick={() => navigateTo('/reports/saldos')}>
                <FaFileAlt className="me-2" title="Saldos"/> <span>Saldos</span>
              </ListGroup.Item>
            </ListGroup>
          )}
          {hasAdminRole && (
            <ListGroup.Item action onClick={() => navigateTo('/logs')}>
              <FaFileAlt className="me-2" title="Logs do Sistema"/> <span>Logs do Sistema</span>
            </ListGroup.Item>
          )}
        </ListGroup>
      </div>
       
      <Offcanvas show={showOffcanvas} onHide={handleOffcanvasClose} className="d-lg-none">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontWeight: 'bold' }}>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ListGroup variant="flush">
            {canAccess('chartsView') && (
              <ListGroup.Item 
                action 
                onClick={() => {
                  navigateTo('/dashboard');
                  handleOffcanvasClose();
                }}
              >
                <FaChartBar className="me-2" /> Dashboard
              </ListGroup.Item>
            )}
            <ListGroup.Item 
              action 
              onClick={() => handleMenuSelect('cadastros')}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <FaFolderOpen className="me-2" /> Cadastros
              </div>
              {selectedMenu === 'cadastros' ? (
                <FaChevronUp style={{ fontSize: '0.8em' }} />
              ) : (
                <FaChevronDown style={{ fontSize: '0.8em' }} />
              )}
            </ListGroup.Item>
            {selectedMenu === 'cadastros' && (
              <ListGroup className="ms-3">
                {canAccess('companyView') && (
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/company');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaBuilding className="me-2" /> Empresas
                  </ListGroup.Item>
                )}
                {canAccess('discountView') && (
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/discounts');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaTag className="me-2" /> Descontos
                  </ListGroup.Item>
                )}
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/farm');
                    handleOffcanvasClose();
                  }}
                >
                  <FaTractor className="me-2" /> Fazendas
                </ListGroup.Item>
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/lot');
                    handleOffcanvasClose();
                  }}
                >
                  <FaBoxes className="me-2" /> Lotes
                </ListGroup.Item>
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/person');
                    handleOffcanvasClose();
                  }}
                >
                  <FaUsers className="me-2" /> Pessoas
                </ListGroup.Item>
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/product');
                    handleOffcanvasClose();
                  }}
                >
                  <FaBox className="me-2" /> Produtos
                </ListGroup.Item>
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/harvest');
                    handleOffcanvasClose();
                  }}
                >
                  <FaSeedling className="me-2" /> Safras
                </ListGroup.Item>
                <ListGroup.Item 
                  action 
                  onClick={() => {
                    navigateTo('/silo');
                    handleOffcanvasClose();
                  }}
                >
                  <FaWarehouse className="me-2" /> Silos
                </ListGroup.Item>
                {canAccess('usersView') && (
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/users');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaUser className="me-2" /> Usuários
                  </ListGroup.Item>
                )}
              </ListGroup>
            )}
            <ListGroup.Item 
              action 
              onClick={() => {
                navigateTo('/romaneios');
                handleOffcanvasClose();
              }}
            >
              <FaClipboardList className="me-2" /> Romaneios
            </ListGroup.Item>
            {canAccess('transferView') && (
              <ListGroup.Item 
                action 
                onClick={() => {
                  navigateTo('/transfer');
                  handleOffcanvasClose();
                }}
              >
                <FaExchangeAlt className="me-2" /> Transferências
              </ListGroup.Item>
            )}
            <ListGroup.Item 
              action 
              onClick={() => handleMenuSelect('relatorios')}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <FaFileAlt className="me-2" /> Relatórios
              </div>
              {selectedMenu === 'relatorios' ? (
                <FaChevronUp style={{ fontSize: '0.8em' }} />
              ) : (
                <FaChevronDown style={{ fontSize: '0.8em' }} />
              )}
            </ListGroup.Item>
              {selectedMenu === 'relatorios' && (
                <ListGroup className="ms-3">
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/reports/romaneio');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaClipboardList className="me-2" /> Romaneios
                  </ListGroup.Item>
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/reports/estoque');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaBox className="me-2" /> Estoque
                  </ListGroup.Item>
                  <ListGroup.Item 
                    action 
                    onClick={() => {
                      navigateTo('/reports/saldos');
                      handleOffcanvasClose();
                    }}
                  >
                    <FaFileAlt className="me-2" /> Saldos
                  </ListGroup.Item>
                </ListGroup>
              )}
            {hasAdminRole && (
              <ListGroup.Item 
                action 
                onClick={() => {
                  navigateTo('/logs');
                  handleOffcanvasClose();
                }}
              >
                <FaFileAlt className="me-2" /> Logs do Sistema
              </ListGroup.Item>
            )}
            </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>

      <div className="content">
        <Outlet />
      </div>

      <ConfirmationModal
        show={showLogoutModal}
        handleClose={handleModalClose}
        handleConfirm={handleLogoutConfirm}
        title="Confirmação de Logout"
        message="Tem certeza que deseja sair?"
      />
    </div>
  );
};

export default Home;